import { TextInput } from '../baseInputs'

type Props = {
  helper?: string
  name?: string
  label?: string
  optional?: boolean
}

const VehicleRegNo = ({ helper, optional, name, label, ...rest }: Props) => {
  const defaultName = name || 'reg_num'
  const inputLabel = label || 'Vehicle registration number'

  return (
    <TextInput
      name={defaultName}
      label={inputLabel}
      helper={helper}
      optional={optional}
      uppercase={true}
      {...rest}
    />
  )
}

export default VehicleRegNo
